<template>
    <div>
        <Table>
            <TableHead>
                <TableHeadCell>User</TableHeadCell>
            </TableHead>
            <TableBody>
                <TableBodyRow
                    v-for="(
                        companyUserAggregate, index
                    ) in companyUserAggregates"
                    :key="companyUserAggregate.companyUser.id.value"
                >
                    <TableBodyRowCell>
                        <input
                            type="hidden"
                            :name="`${RequestBodyKeyEnum.App_UpdateService_EnabledCompanyUsers}[${index}][${RequestBodyKeyEnum.App_UpdateService_EnabledCompanyUsers_CompanyUserId}]`"
                            :value="companyUserAggregate.companyUser.id.value"
                        />
                        <input
                            type="hidden"
                            :name="`${RequestBodyKeyEnum.App_UpdateService_EnabledCompanyUsers}[${index}][${RequestBodyKeyEnum.App_UpdateService_EnabledCompanyUsers_IsEnabled}]`"
                            value="0"
                        />
                        <CheckboxInput
                            :label="companyUserAggregate.user.getFullName()"
                            :checked="
                                companyUserAggregate.isServiceSelected(
                                    props.serviceId,
                                )
                            "
                            :name="`${RequestBodyKeyEnum.App_UpdateService_EnabledCompanyUsers}[${index}][${RequestBodyKeyEnum.App_UpdateService_EnabledCompanyUsers_IsEnabled}]`"
                            value="1"
                        />
                    </TableBodyRowCell>
                </TableBodyRow>
            </TableBody>
        </Table>
        <template v-if="companyUserAggregates.length === 0">
            <input
                type="hidden"
                :name="`${RequestBodyKeyEnum.App_UpdateService_EnabledCompanyUsers}[]`"
            />
        </template>
    </div>
</template>

<script setup lang="ts">
    import { type PropType } from 'vue'
    import Table from '@/Shared/Component/Table/Table.vue'
    import TableBody from '@/Shared/Component/Table/TableBody.vue'
    import TableBodyRow from '@/Shared/Component/Table/TableBodyRow.vue'
    import TableBodyRowCell from '@/Shared/Component/Table/TableBodyRowCell.vue'
    import CompanyUserAggregate from '@/App/CompanyUser/Entity/CompanyUserAggregate'
    import CheckboxInput from '@/Shared/Component/Forms/CheckboxInput.vue'
    import ServiceID from '@/App/Service/Entity/ServiceID'
    import TableHead from '@/Shared/Component/Table/TableHead.vue'
    import TableHeadCell from '@/Shared/Component/Table/TableHeadCell.vue'
    import { RequestBodyKeyEnum } from '@/Shared/AutoGenerated/RequestFieldEnum'

    const props = defineProps({
        serviceId: {
            type: Object as PropType<ServiceID>,
            required: true,
        },
        companyUserAggregates: {
            type: Array as PropType<CompanyUserAggregate[]>,
            required: true,
        },
    })
</script>
